// extracted by mini-css-extract-plugin
export default {"description":"SimpleDialogInfoPopup__description--3yu"};